import type { InternalLink } from '~/contracts/common/Seo';
import InternalLinkMod from './InternalLinkMod';
import { Container } from './InternalLinkModule.styles';

type OwnProps = {
  links?: InternalLink;
};

export default function InternalLinkModule({ links }: OwnProps) {
  if (!links) return null;

  const { popularMakesModels, ...otherLinkTypes } = links;

  return Object.keys(links).length > 0 ? (
    <Container data-testid="seo-internal-links-section">
      {popularMakesModels?.links?.length > 0 && (
        <InternalLinkMod linksData={popularMakesModels} />
      )}
      {Object.values(otherLinkTypes)
        .filter(Boolean)
        .map(linkData => (
          <InternalLinkMod key={linkData.title} linksData={linkData} />
        ))}
    </Container>
  ) : null;
}
